import { Spinner } from "@/components/ui/spinner";

interface FullPageLoadingProps {
  label?: string;
}

export function FullPageLoading({ label = "Loading…" }: FullPageLoadingProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <Spinner size="xl" />
      <p className="font-inter text-sm text-neutral-500">{label}</p>
    </div>
  );
}
